/***********************************************************************************************************************
/*****************************************              Bar Chart              *****************************************
/***********************************************************************************************************************/

export { useBarChart } from './BarChart';
export { getPropsForAnimated2DWithGradient } from './BarChart/Animated2DWithGradient';
export { useRenderBars } from './BarChart/RenderBars';
export { useRenderStackBars } from './BarChart/RenderStackBars';
export {
  type Animated2DWithGradientPropsType,
  type BarChartPropsType,
  type CommonPropsFor2dand3dBarsType,
  type FocusedBarConfig,
  type RenderBarsPropsType,
  type StackedBarChartPropsType,
  type StackedBarChartPropsTypeForWeb,
  type animatedBarPropTypes,
  type barDataItem,
  type barDataItemNullSafe,
  type defaultLineConfigType,
  type stackDataItem,
  type trianglePropTypes,
} from './BarChart/types';

/************************************************************************************************************************
/*****************************************              Line Chart              *****************************************
/************************************************************************************************************************/

export { useLineChart } from './LineChart';
export { useLineChartBiColor } from './LineChart/LineChartBiColor';
export {
  type LineChartBicolorPropsType,
  type LineChartBicolorPropsTypeForWeb,
  type LineChartPropsType,
  type LineChartPropsTypeForWeb,
  type bicolorLineDataItem,
  type lineDataItem,
  type lineDataItemNullSafe,
} from './LineChart/types';

/************************************************************************************************************************
/*****************************************              Bubble Chart              *****************************************
/************************************************************************************************************************/

export { useBubbleChart } from './BubbleChart';
export {
  type BubbleChartPropsType,
  type bubbleDataItem,
} from './BubbleChart/types';

/***********************************************************************************************************************
/*****************************************              Pie Chart              *****************************************
/***********************************************************************************************************************/

export { usePieChart } from './PieChart';
export { getPieChartMainProps } from './PieChart/main';
export { usePiePro } from './PieChart/pro';
export {
  type PieChartMainProps,
  type PieChartPropsType,
  type pieDataItem,
} from './PieChart/types';

/***********************************************************************************************************************
/************************************          Population Pyramid Chart             ************************************
/***********************************************************************************************************************/

export { usePopulationPyramid } from './PopulationPyramid';
export {
  type PopulationPyramidPropsType,
  type PopulationPyramidPropsTypeReactJS,
  type RulesProps,
  type RulesPropsReactJS,
  type RulesPropsType,
  type TPopulationPyramidPropsType,
  type extendedPopulationPyramidPropsType,
  type popnPyramidDataItem,
  type popnPyramidDataItemReactJS,
} from './PopulationPyramid/types';

/***********************************************************************************************************************
/************************************                Radar Chart                    ************************************
/***********************************************************************************************************************/

export { useRadarChart } from './RadarChart';
export {
  type AsterLinesConfig,
  type GridConfig,
  type GridSectionConfig,
  type PolygonConfig,
  type RadarChartProps,
} from './RadarChart/types';

/***********************************************************************************************************************
/************************************             Common Components                 ************************************
/***********************************************************************************************************************/

export { useAnimatedThreeDBar } from './components/AnimatedThreeDBar';
export { useBarAndLineChartsWrapper } from './components/BarAndLineChartsWrapper';
export { getHorizSectionVals } from './components/BarAndLineChartsWrapper/getHorizSectionsVals';
export { getTopAndLeftForStripAndLabel } from './components/common/StripAndLabel';
export { type StripAndLabelProps } from './components/common/types';

/***********************************************************************************************************************
/*********************************          common utils, constants and types           ********************************
/***********************************************************************************************************************/

export {
  adjustToOffset,
  bezierCommand,
  clone,
  computeMaxAndMinItems,
  getAllArrowProperties,
  getArrowPoints,
  getArrowProperty,
  getAxesAndRulesProps,
  getCumulativeWidth,
  getCurvePathWithSegments,
  getExtendedContainerHeightWithPadding,
  getLabelTextUtil,
  getLighterColor,
  getLineConfigForBarChart,
  getPathWithHighlight,
  getPreviousSegmentsLastPoint,
  getRegionPathObjects,
  getSecondaryDataWithOffsetIncluded,
  getSegmentString,
  getSegmentedPathObjects,
  getXForLineInBar,
  getYForLineInBar,
  maxAndMinUtil,
  pointsWithPaddedRepititions,
  svgPath,
  svgQuadraticCurvePath,
  withinMinMaxRange,
} from './utils';

export {
  AxesAndRulesDefaults,
  BarDefaults,
  BubbleDefaults,
  LineDefaults,
  RANGE_ENTER,
  RANGE_EXIT,
  SEGMENT_END,
  SEGMENT_START,
  STOP,
  chartTypes,
  defaultAnimationDuration,
  defaultArrowConfig,
  defaultBubbleColors,
  defaultLineConfig,
  defaultPointerConfig,
  loc,
  pieColors,
  populationDefaults,
  ruleTypes,
  yAxisSides,
} from './utils/constants';

export {
  CurveType,
  EdgePosition,
  Framework,
  type BarAndLineChartsWrapperTypes,
  type ColorFromToY,
  type DataPointProps,
  type DataSet,
  type DataSetForBubbleChart,
  type DataSetNullSafe,
  type HighlightedRange,
  type HorizSectionsType,
  type IntersectionAreaConfig,
  type LabelLineConfig,
  type LabelsPosition,
  type LineInBarChartPropsType,
  type LineProperties,
  type LineSegment,
  type LineSvgProps,
  type Linecap,
  type Pointer,
  type PointerEvents,
  type RuleType,
  type RuleTypes,
  type RulesConfig,
  type SpreadData,
  type TooltipProps,
  type XAxisConfig,
  type arrowConfigType,
  type horizSectionPropTypes,
  type referenceConfigType,
  type secondaryLineConfigType,
  type secondaryYAxisType,
} from './utils/types';
